import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from "formik";
/** Formik-connected form. */ export const Form = connect((param)=>{
    let { formik: { handleReset, handleSubmit }, ...props } = param;
    return /*#__PURE__*/ _jsx("form", {
        onReset: handleReset,
        onSubmit: handleSubmit,
        noValidate: true,
        ...props
    });
});
Form.displayName = "Form";
export default Form;
